import React from "react";
import { useZipCodeLookup } from "../hooks/useZipCodeLookup";

const CustomerInfoForm = ({ customerInfo, setCustomerInfo }) => {
  const { handleZipChange } = useZipCodeLookup({ customerInfo, setCustomerInfo });

  const inputClasses = "w-full px-4 py-3 bg-white border border-indigo-100 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-gray-700 shadow-sm";
  const labelClasses = "block text-sm font-semibold text-gray-700 mb-2";

  return (
    <div className="slide-in">
      <div className="text-center mb-10">
        <h1 className="text-4xl md:text-5xl font-bold gradient-text mb-4">
          Laminance Order
        </h1>
        <p className="text-gray-600 text-lg">
          Create beautiful cabinet orders with ease
        </p>
      </div>

      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 mb-8 border border-indigo-100">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <div className="w-2 h-6 bg-indigo-500 rounded-full mr-3"></div>
          Customer Information
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className={labelClasses}>First Name</label>
            <input
              type="text"
              className={inputClasses}
              placeholder="Enter first name"
              value={customerInfo.firstName}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, firstName: e.target.value })
              }
            />
          </div>
          
          <div>
            <label className={labelClasses}>Last Name</label>
            <input
              type="text"
              className={inputClasses}
              placeholder="Enter last name"
              value={customerInfo.lastName}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, lastName: e.target.value })
              }
            />
          </div>
          
          <div>
            <label className={labelClasses}>Email Address</label>
            <input
              type="text"
              className={inputClasses}
              placeholder="Enter email address"
              value={customerInfo.email}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, email: e.target.value })
              }
            />
          </div>
          
          <div>
            <label className={labelClasses}>Phone Number</label>
            <input
              type="text"
              className={inputClasses}
              placeholder="Enter phone number"
              value={customerInfo.phone}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, phone: e.target.value })
              }
            />
          </div>
          
          <div className="md:col-span-2">
            <label className={labelClasses}>Address</label>
            <textarea
              className={`${inputClasses} resize-none`}
              placeholder="Enter complete address"
              rows="3"
              value={customerInfo.address}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, address: e.target.value })
              }
            ></textarea>
          </div>

          <div>
            <label className={labelClasses}>Zip Code</label>
            <input
              type="text"
              className={inputClasses}
              placeholder="Enter zip code"
              value={customerInfo.zip}
              onChange={handleZipChange}
            />
          </div>
          
          <div>
            <label className={labelClasses}>City</label>
            <input
              type="text"
              className={`${inputClasses} bg-indigo-50`}
              placeholder="City"
              value={customerInfo.city}
              readOnly
            />
          </div>
          
          <div>
            <label className={labelClasses}>State</label>
            <input
              type="text"
              className={`${inputClasses} bg-indigo-50`}
              placeholder="State"
              value={customerInfo.state}
              readOnly
            />
          </div>

          <div>
            <label className={labelClasses}>Order Date</label>
            <input
              type="date"
              className={inputClasses}
              value={customerInfo.date}
              onChange={(e) =>
                setCustomerInfo({ ...customerInfo, date: e.target.value })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoForm;